module.exports = __webpack_public_path__ + "assets/flickity.217a69ac.svg";